export const COMPANY_INFO = {
  name: "Techoside",
  tagline: "Built by Founders, Delivered by Founders",
  description:
    "A founder-led digital agency. Websites, apps, and marketing for D2C and growing businesses — founder-owned, team-delivered, no drop in quality.",
  email: "contact@techoside.com",
  phone: "+919660564367",
  phone2: "+919116885677",
  address: "Rajasthan, India",
  social: {
    instagram: "#",
    linkedin: "#",
  },
};

export const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "Projects", path: "/projects" },
  { name: "Services", path: "/services" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];

export const FOOTER_LINKS = {
  quickLinks: [
    { name: "Home", path: "/" },
    { name: "Projects", path: "/projects" },
    { name: "Services", path: "/services" },
    { name: "About", path: "/about" },
    { name: "Contact", path: "/contact" },
  ],
  services: [
    { name: "Web Development", path: "/services#web-development" },
    { name: "App Development", path: "/services#app-development" },
    { name: "SEO", path: "/services#seo" },
    { name: "Digital Marketing", path: "/services#digital-marketing" },
    { name: "Video Editing", path: "/services#video-editing" },
    { name: "Photo Editing", path: "/services#photo-editing" },
  ],
  legal: [
    { name: "Terms & Conditions", path: "/terms-and-conditions" },
    { name: "Privacy Policy", path: "/privacy-policy" },
  ],
};

export const STATS = [
  { number: 150, suffix: "+", label: "Projects Completed" },
  { number: 98, suffix: "%", label: "Happy Clients" },
  { number: 8, suffix: "+", label: "Years Experience" },
  { number: 24, suffix: "/7", label: "Support Available" },
];

export const WHY_CHOOSE_US = [
  {
    icon: "Code2",
    title: "Experienced Developers",
    description:
      "Our team consists of senior developers with 8+ years of experience building scalable solutions.",
  },
  {
    icon: "Cpu",
    title: "Modern Technologies",
    description:
      "We use cutting-edge technologies and frameworks to build future-proof digital solutions.",
  },
  {
    icon: "Zap",
    title: "Fast Delivery",
    description:
      "Agile methodology ensures rapid development cycles and on-time project delivery.",
  },
  {
    icon: "Headphones",
    title: "Ongoing Support",
    description:
      "24/7 support and maintenance to keep your digital solutions running smoothly.",
  },
  {
    icon: "Target",
    title: "Result-Oriented Strategy",
    description:
      "Every project is designed with clear goals and measurable outcomes in mind.",
  },
];

export const PROCESS_STEPS = [
  {
    step: 1,
    icon: "MessageSquare",
    title: "Requirement Discussion",
    description:
      "We start by understanding your business goals, target audience, and project requirements.",
  },
  {
    step: 2,
    icon: "Lightbulb",
    title: "Planning & Strategy",
    description:
      "Our team creates a detailed roadmap and strategy to achieve your objectives.",
  },
  {
    step: 3,
    icon: "Palette",
    title: "Design",
    description:
      "We craft beautiful, user-centric designs that align with your brand identity.",
  },
  {
    step: 4,
    icon: "Code",
    title: "Development",
    description:
      "Our developers bring the designs to life with clean, scalable code.",
  },
  {
    step: 5,
    icon: "TestTube",
    title: "Testing",
    description:
      "Rigorous testing ensures your product works flawlessly across all devices.",
  },
  {
    step: 6,
    icon: "Rocket",
    title: "Launch",
    description:
      "We deploy your project and ensure a smooth launch to the public.",
  },
  {
    step: 7,
    icon: "Shield",
    title: "Support",
    description:
      "Ongoing maintenance and support to keep your solution running perfectly.",
  },
];
